const metricNameMapping = (metricName) => {
	const mapping = {
		active_subscriptions: 'Active Subscriptions', // has to be above active consents
		inactive_subscriptions: 'Inactive Subscriptions', //order matters here (active above will trigger first a inactive contains the word active)
		currently_linked_accounts: 'Currently Linked Accounts',
		total_accounts: 'Total Accounts',
		active: 'Active Consents',
		revoked: 'Revoked Consents',
		rejected: 'Rejected Consents',
		expired: 'Expired Consents',
		pending: 'Pending Consent Requests',
		customer: 'Customers Onboarded',
		failed: 'Failed Data Requests',
		successful: 'Successful Data Requests',
	};

	for (const key in mapping) {
		if (metricName.includes(key)) {
			return mapping[key];
		}
	}
	return '';
};

export default metricNameMapping;
